import { styled } from '../../config'
import { Box } from './Box'

export const ScrollbarBox = styled(Box, {
    // scrollbar
    '&::-webkit-scrollbar': {
        width: '4px'
    },
    '&::-webkit-scrollbar-track': {
        background: 'none'
    },
    '&::-webkit-scrollbar-thumb': {
        borderRadius: '8px',
        background: '$gray0400',
        transition: '150ms'
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '$gray0300'
    }
})
